import React, { useState } from "react";

const FilterModal = ({ isOpen, onClose, onApply, filterOptions, isMobile }) => {
  const [filters, setFilters] = useState({
    category: "",
    level: "",
    duration: "",
    eligibility: "",
  });

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    onApply(filters);
  };

  const handleClose = () => {
    setFilters({ category: "", level: "", duration: "", eligibility: "" });
    onClose();
  };

  // Desktop view - Always visible inline filters
  if (!isMobile) {
    return (
      <div className="flex flex-col sm:flex-row gap-2 bg-white py-2 sm:py-4 rounded-lg w-full">
        {["category", "level", "duration", "eligibility"].map((field) => (
          <div key={field} className="w-full sm:w-auto">
            <select
              name={field}
              value={filters[field]}
              onChange={handleSelectChange}
              className="border border-gray-300 rounded-lg p-2 text-sm w-full sm:w-auto focus:outline-none focus:ring-2 focus:ring-primary-color/50"
            >
              <option value="">
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </option>
              {filterOptions[field]?.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        ))}
        <button
          onClick={handleApply}
          className="bg-primary-color text-white py-2 px-4 rounded-lg hover:bg-primary-color/90 transition-colors text-sm w-full sm:w-auto"
        >
          Apply Filters
        </button>
      </div>
    );
  }

  // Mobile view - Modal
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start sm:items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md max-h-[85vh] flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-lg font-medium">Filter Courses</h2>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto flex-1 p-4">
          {["category", "level", "duration", "eligibility"].map((field) => (
            <div key={field} className="mb-4 last:mb-0">
              <label htmlFor={field} className="block font-medium capitalize text-sm mb-1">
                {field}
              </label>
              <select
                id={field}
                name={field}
                value={filters[field]}
                onChange={handleSelectChange}
                className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-primary-color/50"
              >
                <option value="">
                  {field.charAt(0).toUpperCase() + field.slice(1)}
                </option>
                {filterOptions[field]?.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        {/* Footer - Sticky at bottom */}
        <div className="p-4 border-t bg-white sticky bottom-0">
          <div className="flex justify-end space-x-4">
            <button
              onClick={handleClose}
              className="bg-gray-500 text-white py-2 px-4 rounded-lg text-sm hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleApply}
              className={`py-2 px-4 rounded-lg text-sm ${
                Object.values(filters).some((val) => val)
                  ? "bg-primary-color text-white hover:bg-primary-color/90"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
              } transition-colors`}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
